import React from 'react';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
export function EditPackage() {
  return <div className="space-y-6 max-w-2xl mx-auto" data-id="element-239">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-240">Edit Package</h1>

      <Card data-id="element-241">
        <CardContent className="space-y-6 pt-6" data-id="element-242">
          <Input label="Name" defaultValue="Starter Bundle" data-id="element-243" />

          <Select label="Package Types" options={[{
          value: 'generic',
          label: 'Generic Package'
        }, {
          value: 'preset',
          label: 'Preset package'
        }]} data-id="element-244" />

          <Input label="Total Courses" type="number" defaultValue="3" data-id="element-245" />
          <Input label="Price" defaultValue="99.00" data-id="element-246" />
          <Input label="Crossed Price" defaultValue="149.00" data-id="element-247" />
          <Input label="Position" type="number" defaultValue="1" data-id="element-248" />
          <Input label="Publish" defaultValue="yes" data-id="element-249" />

          <div className="pt-4" data-id="element-250">
            <Button data-id="element-251">Submit</Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}